<template>
  <Modal :setModalStyle="setModalStyle">
    <div slot="header" class="modal_header">
      <div class="modal_imgWrap">
        <img :src="require(`@/assets/images/${modalImg}`)">
      </div>
      <div class="modal_closeBtn" v-if="closeType === 'close'">
        <img src="@/assets/images/x_popup.svg" @click.prevent="SET_POPUP(false)">
      </div>
      <div class="modal_closeBtn" v-if="closeType === 'action'">
        <img src="@/assets/images/x_popup.svg" @click.prevent="closeAction()">
      </div>
      <div class="modal_closeBtn" v-if="closeType === 'mobileAction'">
        <img src="@/assets/images/x_popup.svg" @click.prevent="mobileAction()">
      </div>
    </div>
    <div slot="body">
      <p>{{modalBody}}</p>
    </div>
    <div slot="footer" v-if="count === 'single'">
      <div class="modal_btnWrap single">
        <button class="btn confirm" :type="btnType" @click.prevent="SET_POPUP_HEADER(false)" v-text="confirmBtnText"></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'double'">
      <div class="modal_btnWrap double">
        <button class="btn cancel" @click.prevent="SET_POPUP_HEADER(false)" v-text="cancelBtnText">취소</button>
        <button class="btn confirm" :type="btnType" v-text="confirmBtnText" @click.prevent="btnMove()"></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'triple'">
      <div class="modal_btnWrap triple">
        <button class="btn cancel" @click.prevent="SET_POPUP_HEADER(false)" v-text="cancelBtnText">취소</button>
        <button class="btn confirm" :type="btnType" v-text="confirmBtnText" @click.prevent="btnMove()"></button>
      </div>
        <div class="modal_outSide" v-if="outSide === true">
          <div class="mo_imgWrap">
            <img src="@/assets/images/call.svg">
          </div>
          <button class="btn" :type="btnType" v-text="anotherBtnText" @click.prevent="btnMove_another()"></button>
        </div>
    </div>
    <div slot="footer" v-if="count === 'another'">
      <div class="modal_btnWrap single">
        <button class="btn confirm" :type="btnType" @click.prevent="btnMoveClosed()" v-text="confirmBtnText"></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'mobileAction'">
      <div class="modal_btnWrap single">
        <button class="btn confirm" :type="btnType"  @click.prevent="mobileAction()" v-text="confirmBtnText"></button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex'
import Modal from './Modal.vue'

export default {
  props: {
    popupSet2: {
      title: '',
      modalImg: {
        type: String
      },
      content: {
        type: String
      },
      confirmBtnText: {
        type: String
      },
      cancelBtnText: {
        type: String
      },
      anotherBtnText: {
        type: String
      },
      btnType: {
        type: String
      },
      count: {
        type: String,
        default: 'double'
      },
      outSide: {
        default: false
      },
      nextLink: {
        type: String
      },
      nextLink_another: {
        type: String
      },
      bigModal: {
        default: false
      },
      longHeight: {
        default: false
      },
      topImg: {
        default: false
      },
      closeType: {
        type: String,
        default: 'close'
      },
      closeLink: {
        type: String,
        default: '/'
      },
      mobileLink: {
        type: String
      }
    }
  },
  components: {
    Modal
  },
  data () {
    return {
      input: '',
      valid: false,
      modalImg: this.popupSet2.modalImg,
      modalBody: this.popupSet2.content,
      confirmBtnText: this.popupSet2.confirmBtnText,
      cancelBtnText: this.popupSet2.cancelBtnText,
      anotherBtnText: this.popupSet2.anotherBtnText,
      btnType: this.popupSet2.btnType,
      count: this.popupSet2.count,
      outSide: this.popupSet2.outSide,
      nextLink: this.popupSet2.nextLink,
      nextLink_another: this.popupSet2.nextLink_another,
      closeType: this.popupSet2.closeType,
      closeLink: this.popupSet2.closeLink,
      setModalStyle: {
        bigModal: this.popupSet2.bigModal,
        longHeight: this.popupSet2.longHeight,
        topImg: this.popupSet2.topImg,
        specialPick: this.popupSet2.specialPick
      },
      mobileLink: this.popupSet2.mobileLink
    }
  },
  watch: {
    input (v) {
      this.valid = v.trim().length > 0
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations([
      'SET_POPUP_HEADER'
    ]),
    mobileAction () {
      location.href = this.mobileLink
    },
    addPopup () {
      this.SET_POPUP_HEADER(false)
    },
    btnMove () {
      this.$router.push(this.nextLink)
    },
    btnMove_another () {
    },
    btnMoveClosed () {
      this.$router.push(this.nextLink)
      this.SET_POPUP_HEADER(false)
    },
    closeAction () {
      this.$router.push(this.closeLink)
      this.SET_POPUP_HEADER(false)
    }
  }
}
</script>

<style>
</style>
